angular.module('jv.Pending.Approvals.Service', [])
.factory('approvalChain', function ApprovalChain() {
    return function() {
        this.reset = function() {
            this.approvers = [];
            this.status = '';
            this.initiatedDate = new Date(0);
            this.statusDate = undefined;
            this.error = false;
        };
        this.reset();
    };
})
.constant('REJECTED', 'REJECTED')
.constant('RETRACTED', 'RETRACTED')
.constant('APPROVED', 'APPROVED')
.constant('SKIPPED', 'SKIPPED')
.constant('SENTTOALTERNATES', 'SENTTOALTERNATES')
.constant('READ', 'READ')
.constant('INITIAL', 'INITIAL')
.constant('APPROVALSENT', 'APPROVALSENT')
.constant('EDITED', 'EDITED')
.service('approvalChainPrettyStatus', ['REJECTED', 'RETRACTED', 'APPROVED', 'SKIPPED', 'EDITED', function(REJECTED, RETRACTED, APPROVED, SKIPPED, EDITED) {
    this[REJECTED] = i18n.REJECTED;
    this[RETRACTED] = i18n.APPROVAL_PROCESS_RETRACTED;
    this[APPROVED] = i18n.APPROVED;
    this[SKIPPED] = i18n.APPROVAL_PROCESS_SKIPPED;
    this[EDITED] = i18n.APPROVAL_PROCESS_EDITED;
}])
.factory('isApprovalChainRejected', ['REJECTED', 'approvalChainPrettyStatus', function(REJECTED, approvalChainStatus) {
    return function(approvalChain) {
        return ([approvalChainStatus[REJECTED]].indexOf(approvalChain.status) > -1);
    };
}])
.factory('isApprovalChainRetracted', ['RETRACTED', 'approvalChainPrettyStatus', function(RETRACTED, approvalChainStatus) {
    return function(approvalChain) {
        return ([approvalChainStatus[RETRACTED]].indexOf(approvalChain.status) > -1);
    };
}])
.factory('transformApprovalChain', ['approvalChain', 'REJECTED', 'RETRACTED', 'APPROVED', 'SKIPPED', 'SENTTOALTERNATES', 'READ', 'INITIAL', 'APPROVALSENT', 'EDITED', 'approvalChainPrettyStatus', 'isApprovalChainRetracted', 'isApprovalChainRejected', function(ApprovalChain, REJECTED, RETRACTED, APPROVED, SKIPPED, SENTTOALTERNATES, READ, INITIAL, APPROVALSENT, EDITED, approvalChainStatus, isApprovalChainRetracted, isApprovalChainRejected) {
    return function(rawData) {
        var approvalChain = [],
            workingApprovalChain = new ApprovalChain();

        if(angular.isUndefined(rawData) || !angular.isArray(rawData)) {
            return approvalChain;
        }

        function isRejectedStatus(approver) {
            return [REJECTED].indexOf(approver.statusKind) > -1;
        }

        function isRetractedStatus(approver) {
            return [RETRACTED].indexOf(approver.statusKind) > -1;
        }

        function isApprovedStatus(approver) {
            return [APPROVED].indexOf(approver.statusKind) > -1;
        }

        function sentToAlternates(approver) {
            return angular.isDefined(approver.sentToAlternates);
        }

        function approvedByAlternate(approver) {
            return approver.alternateEId !== 'snV9Vfw6';
        }

        function findAlternateApprover(approver) {
            var index = 0,
                length = approver.alternateApprovers.length;

            for ( ; index < length; index++) {
                if (approver.alternateApprovers[index].user.EId === approver.alternateEId) {
                    return approver.alternateApprovers[index].user;
                }
            }

            return;
        }

        function shouldBeApprovalSentStatus(approver) {
            return ([READ].indexOf(approver.statusKind) > -1) && shouldBeSentStatus;
        }

        function isSkippedStatus(approver) {
            return ([SKIPPED].indexOf(approver.statusKind) > -1);
        }

        function isEditedChain(approvalChain) {
            var isEdited = false;
            angular.forEach(approvalChain.approvers, function(approver) {
                if(approver.clear === true) {
                    isEdited = true;
                }
            });
            return isEdited;
        }

        function processApprover(approver) {
            var alternateApprover;
            // Edit status/statusdate as necessary
            // Should update when approver action is Rejected, retracted.
            if(shouldBeApprovalSentStatus(approver)) {
                shouldBeSentStatus = false;
                approver.statusKind = APPROVALSENT;
            }
            if(sentToAlternates(approver)) {
                if((isApprovedStatus(approver) || isRejectedStatus(approver) || isRetractedStatus(approver) || isSkippedStatus(approver))) {
                    if(angular.isDefined(alternateApprover = findAlternateApprover(approver))){
                        approver.alternateFor = approver.user;
                        approver.user = alternateApprover;
                        approver.name = approver.user.fullName;
                        approver.alternateApprovers = [];
                    }
                } else {
                    approver.statusKind = SENTTOALTERNATES;
                    approver.updated = approver.sentToAlternates;
                    angular.forEach(approver.alternateApprovers, function(alternate) {
                        alternate.user.statusKind = APPROVALSENT;
                    });
                }
            }

            return approver;
        }

        function processApproverIntoApprovalChain(approver, approvalChain) {
            var alternateApprover;
            // add approver to approvalChain.approvers
            approvalChain.approvers.push(approver);

            approver = processApprover(approver);

            if(isRejectedStatus(approver)) {
                approvalChain.status = approvalChainStatus[approver.statusKind];
                approvalChain.statusDate = new Date(approver.updated);
                shouldBeSentStatus = false;
            }
            if(isRetractedStatus(approver)) {
                approver.statusKind = INITIAL;
                if(!isApprovalChainRejected(approvalChain)) {
                    //Status kind should be set to RETRACTED and not INITIAL if approval is RETRACTED
                    approver.statusKind = RETRACTED;
                    approvalChain.status = approvalChainStatus[RETRACTED];
                    approvalChain.statusDate = new Date(approver.updated);
                }
            }
            // if Position === 1, approvalChain.initiatedDate = approver.submitted
            if(approver.position === 1) {
                approvalChain.initiatedDate = approver.submitted ? (new Date(approver.submitted)) : '---';
            }
        }

        function isApprovedChain(approvalChain) {
            var _approvedOrSkipped = true,
            _atLeastOneApproved = false;
            angular.forEach(approvalChain.approvers, function(approver) {
                _approvedOrSkipped = _approvedOrSkipped && (isApprovedStatus(approver) || isSkippedStatus(approver));
                _atLeastOneApproved = _atLeastOneApproved || isApprovedStatus(approver);
            });

            return _approvedOrSkipped && _atLeastOneApproved;
        }

        function isSkippedChain(approvalChain) {
            var _skipped = true;
            angular.forEach(approvalChain.approvers, function(approver) {
                _skipped = _skipped && isSkippedStatus(approver);
            });

            return _skipped;
        }

        function finalizeApprovalChain(approvalChain) {
            //We are at the end, so we should make sure the status/date of the approvalChain is correct.
            if(isApprovalChainRejected(approvalChain) || isApprovalChainRetracted(approvalChain)) {
                removeAllApprovalActions(approvalChain.approvers);
                approvalChain.error = true;
                return;
            }
            if(isEditedChain(approvalChain)) {
                // removeAllApprovalActions(approvalChain);
                approvalChain.status = approvalChainStatus[EDITED];
            }
            var lastIndex = approvalChain.approvers.length - 1;
            if(isApprovedChain(approvalChain)) {
                approvalChain.status = approvalChainStatus[APPROVED];
                approvalChain.statusDate = new Date(approvalChain.approvers[lastIndex].updated);
            } else if(isSkippedChain(approvalChain)) {
                approvalChain.status = approvalChainStatus[SKIPPED];
                approvalChain.statusDate = new Date(approvalChain.approvers[lastIndex].updated);
            }
        }

        function endOfChain(i) {
            return ((i + 1) === rawData.length) || (rawData[i + 1].position === 1);
        }

        function removeAllApprovalActions(approvers) {
            angular.forEach(approvers, function(approver) {
                if(angular.isDefined(approver.actions)) {
                    approver.actions = [];
                }
            });
        }

        var i = 0, l = rawData.length, startingIndex = 0,
            shouldBeSentStatus = true;
        for ( ; i < l ; i++) {
            processApproverIntoApprovalChain(rawData[i], workingApprovalChain);
            if(endOfChain(i)) {
                finalizeApprovalChain(workingApprovalChain);
                approvalChain.push(angular.copy(workingApprovalChain));
                workingApprovalChain.reset();
                shouldBeSentStatus = true;
            }
        }

        i = approvalChain.length - 2;
        for ( ; i >= 0; i--) {
            angular.forEach(approvalChain[i].approvers, function(approver) {
                if(angular.isDefined(approver.actions)) {
                    approver.actions = [];
                }
            });
        }

        return approvalChain;
    };
}]);